function joinColumnClasses(item, customClassKey) {
  const column = item || {};
  return [
    column[customClassKey] || column[customClassKey === "className" ? "class-name" : "label-class-name"] || "",
    isSequenceColumn(column) ? "base-table-sequence-column" : "",
    column.nowrap === true ? "base-table-column-nowrap" : "",
  ].filter(Boolean).join(" ");
}

function columnClassName(item) {
  return joinColumnClasses(item, "className");
}

function columnLabelClassName(item) {
  return joinColumnClasses(item, "labelClassName");
}

// action 在内容治理等页面是业务字段；只有明确操作语义才自动固定。
function isOperationColumn(item) {
  return Boolean(item && (item.prop === "operation" || item.label === "操作" || item.operationColumn === true));
}

function shouldNoWrap(value, item) {
  if (isSequenceColumn(item)) return true;
  if (item && item.wrap === true) return false;
  if (item && item.nowrap === true) return true;
  if (value === undefined || value === null || typeof value === "object") return false;

  return Array.from(String(value)).length <= 16;
}

function cellTitle(value, item) {
  return shouldNoWrap(value, item) ? String(value === undefined || value === null ? "" : value) : "";
}

// 仅显式声明的固定编号列读取后端展示契约，不能从 id 字段或标题猜测业务语义。
function isSequenceColumn(item) {
  return Boolean(item && item.sequence === true);
}

function rowSequence(index, page, pagesize) {
  const currentPage = Number.isInteger(page) && page > 0 ? page : 1;
  const pageSize = Number.isInteger(pagesize) && pagesize > 0 ? pagesize : 10;
  return (currentPage - 1) * pageSize + index + 1;
}

// 后端 display_no：正整数（数字或纯数字字符串）才算有效；其他一律视为未编号。
function displayNumber(row) {
  const value = row && row.display_no;
  if (typeof value === "number") return Number.isInteger(value) && value > 0 ? String(value) : "";
  if (typeof value === "string" && /^[1-9]\d*$/.test(value)) return value;
  return "";
}

// 有后端编号显示编号（平台行加前缀）；没有则回退页内行号；连行位置都没有才显示占位。
function fixedRowSequence(row, index, page, pagesize) {
  const number = displayNumber(row);
  if (number) return Number(row.shop_id) === 0 && row.shop_id !== undefined && row.shop_id !== null ? `平台 ${number}` : number;
  if (Number.isInteger(index) && index >= 0) return rowSequence(index, page, pagesize);
  return "—";
}

// 批量编辑器：未保存的新行按位置提示，已保存行按固定编号，未编号时同样退回位置。
function editorRowSequence(row, index) {
  return fixedRowSequence(row, index, 1, 10);
}

// 平台前缀及长整数必须完整显示，按实际内容扩展显式编号列，不改变其他业务列宽度。
function sequenceColumnWidth(item, rows) {
  if (!isSequenceColumn(item)) return item && item.width;
  const textWidth = value => Array.from(String(value)).reduce((width, char) =>
    width + (/[^\x00-\xff]/.test(char) ? 14 : 8), 0);
  return Math.max(Number.parseFloat(item.width) || 70, textWidth(item.label || "序号") + 28,
    ...(rows || []).map((row, index) => textWidth(fixedRowSequence(row, index, 1, 10)) + 28));
}

// 按列名推导最小宽度。
//
// 表头的 .cell 现在是 nowrap(见 baseTable 样式，2026-09-17 1e5ea1bb)，而 Element 的
// .cell 本身带 overflow:hidden + text-overflow:ellipsis：没显式设宽度的列由 el-table
// 平分剩余空间，长列名就会被截成「交易手续…」。page-structure 明确禁止省略号截断，
// 所以这里给这类列兜一个至少放得下列名的宽度。
// 已显式给了 width 或 minWidth 的列一律不动，避免覆盖业务页面自己的排版决定。
function columnMinWidth(item) {
  const column = item || {};
  const explicit = column.minWidth || column["min-width"];
  if (explicit) return explicit;
  if (column.width || isSequenceColumn(column)) return undefined;
  const label = String(column.label || "");
  if (!label) return undefined;
  const textWidth = Array.from(label).reduce((width, char) =>
    width + (/[^\x00-\xff]/.test(char) ? 14 : 8), 0);
  // 24 = 单元格左右 padding 各 10px + 值容器 margin 2px×2；
  // renderHeader 的列名后面还挂着问号图标，再留 20px。
  const extra = typeof column.renderHeader === "function" ? 20 : 0;
  return Math.max(80, Math.ceil(textWidth + 24 + extra));
}

function displayCellValue(row, item, index, page, pagesize) {
  if (isSequenceColumn(item)) return fixedRowSequence(row, index, page, pagesize);
  return row[item.prop];
}

module.exports = {
  cellTitle,
  columnClassName,
  columnLabelClassName,
  columnMinWidth,
  displayCellValue,
  editorRowSequence,
  fixedRowSequence,
  isSequenceColumn,
  isOperationColumn,
  rowSequence,
  sequenceColumnWidth,
  shouldNoWrap,
};
